import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import Cookies from 'universal-cookie'
import { decodeText, encodedText } from '../plugins/encrypt'
import { refreshToken } from '../services/auth'
import http from '../plugins/axios'

const cookies = new Cookies()

const generateToken = (session) => {
  let token = ''
  if (session) {
    const decode = decodeText(session)
    token = JSON.parse(decode)
  }
  return token
}

export const getCredential = createAsyncThunk('auth/getCredential', async () => {
  const session = cookies.get('session')
  let responseCredential = ''
  if (session !== undefined) {
    const sessionMember = generateToken(session)
    const payload = {
      refresh_token: sessionMember.refresh_token
    }
    const response = await refreshToken(payload)
    if (response) {
      responseCredential = response
    }
  } else {
    responseCredential = 'no token available'
  }
  return responseCredential
})

const authData = createSlice({
  name: 'auth',
  initialState: {
    authorization: null,
    isLogin: false,
    isLoading: true
  },
  reducers: {
    update: (state, action) => {
      state.authorization = action.payload.authorization
      state.isLogin = action.payload.isLogin
      state.isLoading = action.payload.isLoading
    }
  },
  extraReducers: {
    [getCredential.pending]: (state) => {
      state.isLoading = true
    },
    [getCredential.fulfilled]: (state, action) => {
      if (action.payload !== 'no token available') {
        http.defaults.headers.common['Authorization'] = `Bearer ${action.payload.access_token}`
        const stringValue = JSON.stringify(action.payload)
        const encodedData = encodedText(stringValue)
        cookies.set('session', encodedData, { path: '/' })
        state.isLoading = false
        state.isLogin = true
        state.authorization = action.payload
      } else {
        state.isLoading = false
        state.authorization = null
        state.isLogin = false
        cookies.remove('session')
      }
    },
    [getCredential.rejected]: (state) => {
      state.isLoading = false
      state.authorization = null
      state.isLogin = false
      cookies.remove('session')
    }
  }
})

export const { update } = authData.actions
export default authData.reducer